<nb-accordion class="mb-4">
  <nb-accordion-item [expanded]="true">
    <nb-accordion-item-header>
      <div class="d-flex align-items-center">
        <i class="far fa-chart-line ms-2"></i>
        <span>گزارش‌گیری</span>
      </div>
    </nb-accordion-item-header>
    <nb-accordion-item-body>
      <div class="row mb-3">
        <div class="col-12 col-lg-12">
          <nb-card>
            <nb-card-header>فقط کاربران لیست</nb-card-header>
            <nb-card-body>
              <app-user-picker
                (add)="includedUsers = $event"
                (remove)="includedUsers = $event"
                [cacheKey]="'transaction_included_users'"
              ></app-user-picker>
            </nb-card-body>
          </nb-card>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <button nbButton status="primary" (click)="getDepositList({ first: 0, rows: limit })">
          گزارش‌گیری
        </button>
      </div>
    </nb-accordion-item-body>
  </nb-accordion-item>
</nb-accordion>
<nb-card>
  <nb-card-header>لیست واریز ریالی</nb-card-header>
  <nb-card-body>
    <div class="d-none d-lg-flex align-items-center mb-2">
      <nb-select
        class="ms-2"
        [selected]="15"
        (selectedChange)="changeRecordPerPageLimit($event)"
        placeholder="تعداد رکورد"
      >
        <nb-option [value]="10">10</nb-option>
        <nb-option [value]="15">15</nb-option>
        <nb-option [value]="25">25</nb-option>
        <nb-option [value]="50">50</nb-option>
        <nb-option [value]="100">100</nb-option>
      </nb-select>
    </div>
    <p-table
      [value]="pagination.data"
      [tableStyleClass]="'table text-center table-striped  stacked-table table-hover'"
      [lazy]="true"
      (onLazyLoad)="getDepositList($event)"
      [alwaysShowPaginator]="false"
      [autoLayout]="true"
      [paginator]="true"
      [rows]="limit"
      [totalRecords]="pagination.totalRecords"
      [loading]="loading"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>شناسه</th>
          <th>کاربر</th>
          <th>نام بانک</th>
          <th>شماره کارت/شبا</th>
          <th>وضعیت</th>
          <th>درگاه بانکی</th>
          <th>مقدار</th>
          <th>شناسه تراکنش</th>
          <th>پیام</th>
          <th>تاریخ ایجاد</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-deposit>
        <tr>
          <td>{{ deposit.id }}</td>
          <td>
            <a
              class="text-primary"
              [routerLink]="deposit.user?.id ? '/dashboard/user/' + deposit.user?.id : null"
            >
              {{
              deposit.user?.firstName || deposit.user?.lastName
                ? deposit.user.firstName + ' ' + deposit.user.lastName
                : '-'
              }}
            </a>
          </td>
          <td>
            <ng-container *ngIf="deposit.userCreditCard; else iban">
              {{ deposit.userCreditCard | bankName : 'CARD' | translateBankName }}
            </ng-container>
            <ng-template #iban>
              {{ deposit.userIban | bankName : 'IBAN' | translateBankName }}
            </ng-template>
          </td>
          <td class="code">
            <ng-container *ngIf="deposit.userCreditCard; else empty">
              <i
                (click)="copy(deposit.userCreditCard, 'شماره کارت کپی شد.')"
                class="far fa-copy ms-1 cursor-pointer text-primary"
              ></i>
              {{ deposit.userCreditCard }}
            </ng-container>
            <ng-template #empty>
              <i
                (click)="copy(deposit.userIban, 'شماره شبا کپی شد.')"
                class="far fa-copy ms-1 cursor-pointer text-primary"
              ></i>
              {{ deposit.userIban }}
            </ng-template>
          </td>
          <td
            [class.text-success]="deposit.callbackStatus === 1"
            [class.text-danger]="deposit.callbackStatus !== 1"
          >
            {{ deposit.callbackStatus === 1 ? 'موفق' : 'ناموفق' }}
          </td>
          <td>{{deposit.provider}}</td>
          <td>
            {{ deposit.amount | number : '1.0-8' }}
          </td>
          <td class="code">
            <i
              *ngIf="deposit.callbackTrackingCode"
              (click)="copy(deposit.callbackTrackingCode, 'شناسه تراکنش کپی شد.')"
              class="far fa-copy ms-1 cursor-pointer text-primary"
            ></i>
            {{ deposit.callbackTrackingCode ?? '-' }}
          </td>
          <td>
            {{ deposit.callbackMessage ?? '-' }}
          </td>
          <td>
            {{ deposit.createdAt | dateFormat : 'HH:mm jYYYY/jMM/jDD' }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </nb-card-body>
</nb-card>
